import { styled } from "@mui/material/styles";
import IconButton, { IconButtonProps } from "designSystem/components/button/IconButton";
import { itemListStyle } from "designSystem/styles/style-functions";
import React from "react";

interface IconButton3DProps extends IconButtonProps {
    fontSize?: number;
}

const StyledIconButton = styled(IconButton)(
	({ theme }) => ({        
		...itemListStyle(theme),
	}),
);

const IconButton3D = (props:IconButton3DProps) => {
	const { fontSize, sx, ...otherProps } = props;
	return (
		<StyledIconButton
			customSize={26}
			design="iconOnly"
			sx={{
				"& .MuiSvgIcon-root" : {
					fontSize: fontSize || 16,
				},
				...sx,
			}}
			tooltipProps={{
				placement: "right",
			}}
			{...otherProps}
		/>
	);
};

export default IconButton3D;